import { create } from 'zustand';

export const useGraphTabsStore = create(set => ({
  tab: 'study_area',
  setTab: nextTab =>
    set(state => {
      return { tab: nextTab };
    }),
}));
